import { useState } from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import "./styles/MainPage.css";
import branch from "/assets/1.png";
import user from "/assets/2.png";
import pole from "/assets/3.png";
// เพิ่มสาขา
import AddBranchModal from "../../components/addBranchForm";
// เพิ่มผู้ใช้งาน
import Ouh from "../../components/addUserForm";
// เพิ่มเสา
import AddPoleModal from "../../components/addPoleForm";

function MainPage() {
  const getCurrentTimeGreeting = () => {
    const currentTime = new Date();
    const hours = currentTime.getHours();

    if (hours >= 5 && hours < 12) {
      return "สวัสดีตอนเช้า";
    } else if (hours >= 12 && hours < 18) {
      return "สวัสดีตอนกลางวัน";
    } else {
      return "สวัสดีตอนเย็น";
    }
  };

  const [isAddBranchModalOpen, setIsAddBranchModalOpen] = useState(false);
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const [isAddPoleModalOpen, setIsAddPoleModalOpen] = useState(false);
  const [loadingBranch, setLoadingBranch] = useState(false);
  const [loadingUser, setLoadingUser] = useState(false);
  const [loadingPole, setLoadingPole] = useState(false);

  const openAddBranchModal = () => {
    setLoadingBranch(true);
    setTimeout(() => {
      setIsAddBranchModalOpen(true);
      setLoadingBranch(false);
    }, 1000); // 1 second delay
  };
  const openAddUserModal = () => {
    setLoadingUser(true);
    setTimeout(() => {
      setIsAddUserModalOpen(true);
      setLoadingUser(false);
    }, 1000); // 1 second delay
  };
  const openAddPoleModal = () => {
    setLoadingPole(true);
    setTimeout(() => {
      setIsAddPoleModalOpen(true);
      setLoadingPole(false);
    }, 1000); // 1 second delay
  };

  const handleUserModalConfirmButtonClick = () => {
    setIsAddUserModalOpen(false);

    // ลบข้อมูลจาก sessionStorage
    sessionStorage.removeItem("newUser");
    sessionStorage.removeItem("selectedBrightness");
    sessionStorage.removeItem("toggleSwitchState");
    sessionStorage.removeItem("selectedItems");
  };

  const handleBranchModalClose = () => {
    setIsAddBranchModalOpen(false);
  };

  const handleAddPoleModalClose = () => {
    setIsAddPoleModalOpen(false);
  };

  return (
    <div className="containerPage">
      <br />
      <br />

      {isAddBranchModalOpen && (
        <AddBranchModal closeModal={handleBranchModalClose} />
      )}
      {isAddUserModalOpen && (
        <Ouh onClose={handleUserModalConfirmButtonClick} />
      )}
      {isAddPoleModalOpen && (
        <AddPoleModal onClose={handleAddPoleModalClose} />
      )}

      <h1 className="getCurrentTimeGreeting">{getCurrentTimeGreeting()}</h1>

      <div className="mainSectionAdmin">
        <div className="branch-users-pole">
          <img src={branch} alt="branch" />
          <Button
            variant="contained"
            onClick={openAddBranchModal}
            className="add-branch-button"
            disabled={loadingBranch}
            sx={{
              fontFamily: '"IBM Plex Sans Thai", sans-serif',
              boxShadow: "none",
              backgroundColor: "#2762f8",
              ":hover": {
                backgroundColor: "#003cd3",
                boxShadow: "none",
              },
              "&.Mui-disabled": {
                backgroundColor: "#2762F8",
              },
            }}
          >
            {loadingBranch ? <CircularProgress size={24} color="inherit" /> : "+ เพิ่มสาขา"}
          </Button>
        </div>
        <div className="branch-users-pole">
          <img src={user} alt="user" />
          <Button
            variant="contained"
            onClick={openAddUserModal}
            className="add-user-button"
            disabled={loadingUser}
            sx={{
              fontFamily: '"IBM Plex Sans Thai", sans-serif',
              boxShadow: "none",
              backgroundColor: "#2762f8",
              ":hover": {
                backgroundColor: "#003cd3",
                boxShadow: "none",
              },
              "&.Mui-disabled": {
                backgroundColor: "#2762F8",
              },
            }}
          >
            {loadingUser ? <CircularProgress size={24} color="inherit" /> : "+ เพิ่มผู้ใช้งาน"}
          </Button>
        </div>
        <div className="branch-users-pole">
          <img src={pole} alt="pole" />
          <Button
            variant="contained"
            onClick={openAddPoleModal}
            className="add-pole-button"
            disabled={loadingPole}
            sx={{
              fontFamily: '"IBM Plex Sans Thai", sans-serif',
              boxShadow: "none",
              backgroundColor: "#2762f8",
              ":hover": {
                backgroundColor: "#003cd3",
                boxShadow: "none",
              },
              "&.Mui-disabled": {
                backgroundColor: "#2762F8",
              },
            }}
          >
            {loadingPole ? <CircularProgress size={24} color="inherit" /> : "+ เพิ่มเสา"}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default MainPage;
